export { webAttributionPlugin } from './web-attribution';
export { webAttributionPlugin as plugin } from './web-attribution';
import * as Types_1 from './typings/web-attribution';
export { Types_1 as Types };
//# sourceMappingURL=index.js.map